import { useState } from 'react'
import logo from './assets/logo.svg'
import duck from './assets/duck.svg'
import waveforeground from './assets/wave-foreground.svg'
import wavebackground from './assets/wave-background.svg'

export default () => {
  const [isHoveringOverPopUp, setIsHoveringOverPopUp] = useState(false)

  function lobbyIDGenerator(){
    return (Math.floor(Math.random() * 360000 )); // this gives between 0 and 360000
  }

  return <> 
  <div id="popupOverlay" onClick={() => {
    if (!isHoveringOverPopUp) {
      document.getElementById("popupOverlay").style.display = "none";
    }
  }}>
    <div className="popupText" onMouseEnter={() => setIsHoveringOverPopUp(true)} onMouseLeave={() => setIsHoveringOverPopUp(false)}>
      <input id="lobbyIDInput" type="text" placeholder='Pond #' required/>
      <button onClick={ () => {
        let id = document.getElementById("lobbyIDInput").value;
        window.location.href = window.location.href += "?pond=" + id}} type="button" id="popupButton" className="btn">Migrate</button>
    </div>
  </div>
  <div className="Lobby">
    
    <main>
      <img className='logo' src={logo} />
      {/* <img className="yeet" src={duck} /> */}
      <h1>Welcome to the pondscape - Find your own rubber ducky debugging buddy!</h1>
      <div className="actions">
        <button onClick={() => {window.location.href = window.location.href += "?pond=" + lobbyIDGenerator()} } type="button" className="btn btn-primary">Create Pond</button>
        <button onClick={() => { 
          document.getElementById("popupOverlay").style.display = "block";
        }} type="button" className="btn btn-secondary">Join Pond</button>
      </div>
    </main>
    <Waves />
  </div>
  </>
}

export const Waves = () => 
  <div className="Waves">
    <img className='wave-2' src={wavebackground} />
    <img className='wave-1' src={waveforeground} />
  </div>